import React, { useState } from 'react'
import { GrMenu } from 'react-icons/gr'

const SuperAdminAnalysis = () => {
    const [embedURL, setEmbedURL] = useState("https://mixpanel.com/project/3385728/view/3891000/app/boards/embed#id=7900621");

    return (
        <div className="col-12 col-xxl-10 superAdmin-rightSide-total-height overflow-hidden">
            <div className="col-12 superAdmin-rightSide-Component-name-height ">
                <div className="container-fluid px-lg-4 h-100">
                    <div className="row align-items-center h-100 ">
                        <div className="col-6">
                            <h5>Analysis</h5>
                        </div>

                        <div className="col-6 text-end d-xxl-none">
                            <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#superAdminSidebar" aria-controls="superAdminSidebar">
                                <GrMenu className='fs-4' />
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <div className="col-12 superAdmin-rightSide-Component-content-height placeholder-glow">
                <div className="container-fluid px-lg-4 h-100">
                    <div className="row text-center justify-content-center">
                        <div className="col-12 col-md-6 col-lg-5 row g-3">
                            <div className="col">
                                <button type="button" className='btn btn-brand-color' onClick={() => setEmbedURL("https://mixpanel.com/project/3385728/view/3891000/app/boards/embed#id=7900621")}>Board</button>
                            </div>

                            <div className="col">
                                <button type="button" className='btn btn-brand-color' onClick={() => setEmbedURL("https://mixpanel.com/project/3385728/view/3891000/app/events/embed")}>Events</button>
                            </div>

                            <div className="col">
                                <button type="button" className='btn btn-brand-color' onClick={() => setEmbedURL("https://mixpanel.com/project/3385728/view/3891000/app/users/embed")}>Users</button>
                            </div>
                        </div>
                    </div>

                    <div className="h-100 m-2 mt-5 m-lg-5">
                        <div className="position-relative h-100">
                            <iframe src={embedURL} style={{ top: 0, left: 0, width: "100%", height: " 85%", position: "absolute", border: 0, borderRadius: ".7rem" }} title="events" allowFullScreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SuperAdminAnalysis